import { ExportStatus } from "../../main/constants/export.constants";

export default class EventShowCtrl {
    constructor($scope, $window, $state, $location, $filter, $rootScope, $stateParams, SweetAlert, Subscriber, Event, Events, SideMenu, Tag) {
        SideMenu.setActive('event');

        this._scope = $scope;
        this._rootScope = $rootScope;
        this._state = $state;
        this._translator = $filter('translate');
        this._stateParams = $stateParams;
        this._window = $window;
        this._location = $location;

        this.eventRepo = Event;
        this.tagRepo = Tag;
        this.alerter = SweetAlert;
        this.subscriberRepo = Subscriber;
        this.eventHandler = Events;

        this.searching = false;
        this.loading = false;
        this.status = this._stateParams.eventSubscribersStatus;
        this.fieldNames = {
            f_name: $filter('translate')('EVENT:SHOW:FIRST_NAME'),
            l_name: $filter('translate')('EVENT:SHOW:LAST_NAME'),
            posted_at: $filter('translate')('EVENT:SHOW:POSTED_AT')
        };

        this.statusIdToNameMap = {
            1: 'draft',
            2: 'current',
            3: 'completed',
            4: 'scheduled'
        };

        this.subscriberStatusToTagMap = {
            'attending': 'attendersTag',
            'unsubscribed': 'unsubscribedTag',
        };

        this.eventRepo.find(this._stateParams.id).then((event) => {
            this.event = event.data;
            let tagId = this.event[this.subscriberStatusToTagMap[this.status]].id;
            this.repositoryAttributes = { tagId: tagId };

            this.tagRepo.getExportById(this._stateParams.exportId).then((progress) => {
                if (Array.isArray(progress.data)) {
                    progress.data.forEach((progress) => {
                        this.exportProgressHandler(progress?.status?.value);
                    });
                } else {
                    this.exportProgressHandler(progress.data?.status?.value);
                }
            }).catch((error) => {
                console.error(error);
                this.exportActive = false;
                this.eventHandler.flashEvent('error', this._translator('NOTIFICATION:TYPE:EXPORT_FAILED_HEADER'));
            });

            this.eventRepo.getFlowStatistics(this.event.id).then((data) => {
                this.counts = data;
            });
        });

        this._rootScope.$on('tag:export:completed', (event, url) => {
            this.exportActive = false;
            this.exportFileUrl = url;
        });

        this._scope.$on('event:subscriber:showData', (event, subscriber) => {
            this.subscriber = subscriber;
            this.eventData = [];
            this.loading = true;

            this._scope.$broadcast('event:attenderInfo:show');

            this.subscriberRepo.customFields(subscriber.id).then((response) => {
                angular.forEach(response.data, (group) => {
                    let id = this._stateParams.id;

                    if (group.name == "Event" + id) {
                        this.eventData = group.fields;
                        this.formatData(this.eventData);
                    }
                });

                this.loading = false;
            });
        });
        this._scope.$watch(() => this.status, (newStatus, oldStatus) => {
            if (newStatus !== oldStatus) {
                switch (newStatus) {
                    case 'surveyed':
                        this.getSurveyedSubscribers();
                        break;
                    default:
                        this.repositoryAttributes.tagId = this.event[this.subscriberStatusToTagMap[newStatus]].id;
                        this._scope.$broadcast('subscriberGrid:reload');
                }
            }
        });

        this._scope.$on('event:attenderInfo:removeSubscription', () => {
            this.removeSubscription();
        });

        this._scope.$on('account:changed', () => {
            this._state.go('event.index');
        });
    }

    exportProgressHandler(statusValue) {
        if (statusValue === ExportStatus.Finished) {
            if (this._stateParams.isFileExport) {
                this.tagRepo.getExportDownloadLink(this._stateParams.exportId).then((download) => {
                    this.exportFileUrl = download.data.url;
                });
            }
            this.exportActive = false;
        } else {
            this.exportActive = true;
            this._rootScope.$emit('progress:start', 'tag-export');
        }
    }

    setStatus(status) {
        this.status = status;
    };

    toExport() {
        this._state.go('event.exportAttending', {
            id: this.event.id,
            tagId: this.event[this.subscriberStatusToTagMap[this.status]].id,
            eventSubscribersStatus: this.status
        });
    };

    downloadExport() {
        this._window.open(this.exportFileUrl);
    };

    backToEvent() {
        this._state.go('event.folder', { folder: this.statusIdToNameMap[this.event.event_status_id]})
    };

    removeSubscription() {
        this.alerter.swal({
            title: this._translator('EVENT:FLASH:REMOVE_SUBSCRIPTION_HEADER'),
            text: this._translator('EVENT:FLASH:REMOVE_SUBSCRIPTION_BODY'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: this._translator('GLOBAL:YES'),
            cancelButtonText: this._translator('GLOBAL:NO')
        }, (isConfirm) => {
            if (isConfirm) {
                this.eventRepo.unsubscribe(this.event.id, this.subscriber.id).then(() => {
                    this._scope.$broadcast('event:attenderInfo:close');
                    this.eventHandler.flashEvent('notification', this._translator('EVENT:FLASH:SUBSCRIPTION_REMOVED'));
                    this.subscriber = null;
                    this.counts['attending'] -= 1;
                    this.counts['unsubscribed'] += 1;
                    this._scope.$broadcast('subscriberGrid:reload');
                });
            }
        });
    };

    formatData(data) {
        angular.forEach(data, (field) => {
            if (this.fieldNames[field.name]) {
                field.name = this.fieldNames[field.name];
            }
        });
    };

    getSurveyedSubscribers() {
        this.loading = true;
        this.surveyedSubscribers = [];
        this.eventRepo.getSurveyedSubscribers(this._stateParams.id).then((response) => {
            let subscribers = response.data;
            angular.forEach(subscribers, (subscriber) => {
                this.formatData(subscriber.custom_fields);
            });
            this.surveyedSubscribers = subscribers;
            this.loading = false;
        });
    }

    updateNotificationEmail() {
        this.eventRepo.saveMetadata(this.event).then((event) => {
            if (event.data.metadata.data.notification_email) {
                this.eventHandler.flashEvent('notification', this._translator('EVENT:FLASH:NOTIFICATION_UPDATED_ADDED'));
            } else {
                this.eventHandler.flashEvent('notification', this._translator('EVENT:FLASH:NOTIFICATION_UPDATED_REMOVED'));
            }
        }, (error) => {
            if (error.data.error === 'Invalid email') {
                return this.eventHandler.flashEvent('error', this._translator('SETTING:ERRORS:EMAIL'));
            } else {
                return this.eventHandler.flashEvent('error', this._translator('GLOBAL:ERROR:DEFAULT'));
            }
        });
    }
};
